import { c as _c } from "react/compiler-runtime";
import type { ApiWaveParticipationRequirement } from "@/generated/models/ApiWaveParticipationRequirement";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import type { CreateWaveDropsConfig, CreateWaveDropsRequiredMetadata } from "@/types/waves.types";
import CreateWaveDropsMetadata from "./metadata/CreateWaveDropsMetadata";
import CreateWaveDropsSubmissionMode from "./submission-mode/CreateWaveDropsSubmissionMode";
import CreateWaveDropsTypes from "./types/CreateWaveDropsTypes";
import CreateWaveTermsOfService from "./terms/CreateWaveTermsOfService";
export default function CreateWaveDrops(t0) {
  const $ = _c(45);
  const {
    waveType,
    drops,
    errors,
    setDrops
  } = t0;
  let t1;
  if ($[0] !== drops || $[1] !== setDrops) {
    t1 = e => {
      const noOfApplicationsAllowedPerParticipant = parseInt(e.target.value);
      const isValid = !isNaN(noOfApplicationsAllowedPerParticipant) && noOfApplicationsAllowedPerParticipant > 0;
      setDrops({
        ...drops,
        noOfApplicationsAllowedPerParticipant: isValid ? noOfApplicationsAllowedPerParticipant : null
      });
    };
    $[0] = drops;
    $[1] = setDrops;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onNoOfApplicationsAllowedPerParticipantChange = t1;
  let t2;
  if ($[3] !== drops || $[4] !== setDrops) {
    t2 = types => {
      setDrops({
        ...drops,
        requiredTypes: types
      });
    };
    $[3] = drops;
    $[4] = setDrops;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onRequiredTypeChange = t2;
  let t3;
  if ($[6] !== drops || $[7] !== setDrops) {
    t3 = requiredMetadata => {
      setDrops({
        ...drops,
        requiredMetadata
      });
    };
    $[6] = drops;
    $[7] = setDrops;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onRequiredMetadataChange = t3;
  let t4;
  if ($[9] !== drops || $[10] !== setDrops) {
    t4 = submissionStrategy => {
      setDrops({
        ...drops,
        submissionStrategy
      });
    };
    $[9] = drops;
    $[10] = setDrops;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onSubmissionStrategyChange = t4;
  const isNotChatType = waveType !== ApiWaveType.Chat;
  let t5;
  if ($[12] !== drops || $[13] !== setDrops) {
    t5 = terms => {
      setDrops({
        ...drops,
        terms,
        signatureRequired: !!terms
      });
    };
    $[12] = drops;
    $[13] = setDrops;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const onTermsChange = t5;
  let t6;
  if ($[15] !== drops.submissionStrategy || $[16] !== errors || $[17] !== isNotChatType || $[18] !== onSubmissionStrategyChange) {
    t6 = isNotChatType && <CreateWaveDropsSubmissionMode submissionStrategy={drops.submissionStrategy} errors={errors} onChange={onSubmissionStrategyChange} />;
    $[15] = drops.submissionStrategy;
    $[16] = errors;
    $[17] = isNotChatType;
    $[18] = onSubmissionStrategyChange;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const t7 = isNotChatType ? "tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-700 tw-pt-6" : "";
  let t8;
  if ($[20] !== drops.requiredTypes || $[21] !== onRequiredTypeChange) {
    t8 = <CreateWaveDropsTypes requiredTypes={drops.requiredTypes} onRequiredTypeChange={onRequiredTypeChange} />;
    $[20] = drops.requiredTypes;
    $[21] = onRequiredTypeChange;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== drops.requiredMetadata || $[27] !== errors || $[28] !== onRequiredMetadataChange) {
    t10 = <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-700 tw-pt-6"><CreateWaveDropsMetadata requiredMetadata={drops.requiredMetadata} errors={errors} onRequiredMetadataChange={onRequiredMetadataChange} /></div>;
    $[26] = drops.requiredMetadata;
    $[27] = errors;
    $[28] = onRequiredMetadataChange;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== drops.noOfApplicationsAllowedPerParticipant || $[31] !== isNotChatType || $[32] !== onNoOfApplicationsAllowedPerParticipantChange) {
    t11 = isNotChatType && <div className="tw-flex tw-flex-col tw-gap-y-2 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-700 tw-pt-6"><div className="tw-group tw-relative tw-w-full"><input type="text" value={drops.noOfApplicationsAllowedPerParticipant !== null ? drops.noOfApplicationsAllowedPerParticipant.toString() : ""} onChange={onNoOfApplicationsAllowedPerParticipantChange} id="no-of-applications-allowed-per-participant" autoComplete="off" className={`${drops.noOfApplicationsAllowedPerParticipant ? "tw-text-primary-400 focus:tw-text-white" : "tw-text-white"} tw-peer tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-border-iron-600 tw-bg-iron-900 tw-px-4 tw-py-4 tw-text-base tw-font-medium tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-650 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-border-blue-500 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 sm:tw-text-sm`} placeholder=" " /><label htmlFor="no-of-applications-allowed-per-participant" className="tw-absolute tw-start-1 tw-top-2 tw-z-10 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-cursor-text tw-bg-iron-900 tw-px-2 tw-text-base tw-font-normal tw-text-iron-500 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-900 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4">Maximum number of simultaneous submissions per participant</label></div><p className="tw-text-sm tw-font-medium tw-text-iron-400">Optional. Unlimited if left blank.</p></div>;
    $[30] = drops.noOfApplicationsAllowedPerParticipant;
    $[31] = isNotChatType;
    $[32] = onNoOfApplicationsAllowedPerParticipantChange;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== drops.terms || $[35] !== isNotChatType || $[36] !== onTermsChange || $[37] !== waveType) {
    t12 = isNotChatType && <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-700 tw-pt-6"><CreateWaveTermsOfService waveType={waveType} terms={drops.terms} setTerms={onTermsChange} /></div>;
    $[34] = drops.terms;
    $[35] = isNotChatType;
    $[36] = onTermsChange;
    $[37] = waveType;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t12 || $[42] !== t6 || $[43] !== t9) {
    t13 = <div className="tw-flex tw-flex-col tw-gap-y-8">{t6}{t9}{t10}{t11}{t12}</div>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
    $[42] = t6;
    $[43] = t9;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
}